import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import PageHelmet from "../../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import Slider from "react-slick";
import {slickDot, slickDot2} from "../../page-demo/script";
import FooterTwo from "../../component/footer/FooterTwo";
import ProductsLeft from "../../component/ProductsLeft";
import ProductsRight from "../../component/ProductsRight";
import ParticlesPage from "../../component/Particals";


const listA = [
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_1.webp',
        category: '',
        title: ''
    },
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_2.webp',
        category: '',
        title: ''
    },
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_3.webp',
        category: '',
        title: ''
    },
]

const listB = [
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_4.webp',
        category: '',
        title: ''
    },
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_5.webp',
        category: '',
        title: ''
    },
    {
        image: '../assets/images/products/Molecular_Biology_Reagents/Equip_Therm_6.webp',
        category: '',
        title: ''
    },
]

const MolecularBiologyReagents = (props) =>{
    return(
        <React.Fragment>
            {/* Start Pagehelmet  */}
            <PageHelmet pageTitle={props.t("_HOME_SERVICE_TITLE_4_")} />
            {/* End Pagehelmet  */}

            <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
            <div className="slider-activation slider-creative-agency with-particles">
                <div className="frame-layout__particles">
                    <ParticlesPage/>
                </div>
            </div>
            {/* Start Breadcrump Area */}
            <div className="rn-page-title-area pt--120 pb--190 bg_image " style={{backgroundImage: `url("../assets/images/bg/bg-image-5.jpg")`}} data-black-overlay="5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="rn-page-title text-center pt--100">
                                <h2 className="title " style={{color :'#c6c9d8'}}>{props.t("_HOME_SERVICE_TITLE_4_")}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Breadcrump Area */}

            {/* Start Page Wrapper */}
            <div className="rn-service-details  bg_color--1">
                <div className="container">
                    <div className="row">
                        <ProductsLeft
                            imagesList={listA}
                            title={props.t('_SERVICE_DETAIL_MOLECULAR_BIOLOGY_TITLE_1')}
                            description1={props.t('_SERVICE_DETAIL_MOLECULAR_BIOLOGY_DESCRIPTION_1a')}
                        />
                        <ProductsRight
                            imagesList={listB}
                            title={props.t('_SERVICE_DETAIL_MOLECULAR_BIOLOGY_TITLE_2')}
                            description1={props.t('_SERVICE_DETAIL_MOLECULAR_BIOLOGY_DESCRIPTION_2a')}
                            description2={props.t('_SERVICE_DETAIL_MOLECULAR_BIOLOGY_DESCRIPTION_2b')}
                        />

                        <div className="col-lg-12">
                            <div className="service-details-inner">

                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* End Page Wrapper */}

            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}

            <FooterTwo />

        </React.Fragment>
    )
}

export default withTranslation()(MolecularBiologyReagents);
